module.exports = __webpack_public_path__ + "static/BI-illustration-6f808e96d381c35333466d3e9f226f47.svg";